import request from '../utils/request';

export async function getChains() {
  return request('/api/chains');
}
